// extracted by mini-css-extract-plugin
export var basic = "teaser-module--basic--36ca8";
export var border = "teaser-module--border--67878";
export var content = "teaser-module--content--dd3f6";
export var ctas = "teaser-module--ctas--8f11c";
export var description = "teaser-module--description--68f73";
export var image = "teaser-module--image--24752";
export var imageLeft = "teaser-module--image-left--78a7e";
export var inner = "teaser-module--inner--11d44";
export var title = "teaser-module--title--2cf65";